<script setup lang="ts">
import { type StatblockData } from './statblock'
import AbilityScore from './AbilityScore.vue'

defineProps<{
  stats: StatblockData
}>()
</script>

<template>
  <div class="abilities">
    <table class="ability-scores nostripes keep-empty">
      <thead>
        <tr>
          <th></th>
          <th></th>
          <th>Mod</th>
          <th>Save</th>
          <th></th>
          <th></th>
          <th>Mod</th>
          <th>Save</th>
          <th></th>
          <th></th>
          <th>Mod</th>
          <th>Save</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <AbilityScore :stats="stats" stat="str" />
          <AbilityScore :stats="stats" stat="dex" />
          <AbilityScore :stats="stats" stat="con" />
        </tr>
        <tr>
          <AbilityScore :stats="stats" stat="int" />
          <AbilityScore :stats="stats" stat="wis" />
          <AbilityScore :stats="stats" stat="cha" />
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style lang="postcss">
.abilities {
  margin-top: -0.25em;
  margin-bottom: 0.75em;

  .ability-scores {
    width: 100%;
    display: table !important; /* overrides the mobile override */
    margin: 0;

    th,
    td {
      padding: 0.1rem;
      text-align: center;
    }
    th {
      font-size: 0.6em;
      font-weight: 600;
      text-transform: uppercase;
      color: var(--text);
    }

    .name {
      font-weight: 600;
      color: var(--text-highlight);
      padding-right: 0.25em;
      text-align: right;

      &:not(:first-child) {
        padding-left: 0.5rem;
      }
    }

    .mod,
    .save {
      color: var(--text-highlight);
    }
  }
}
</style>
